 export  const links = [
    {name:'Registration Services',submenu:'true',sublinks:[
        {
           
            sublink:[
                {name:'GST Registration', link:'/gst-registration'},
                {name:'Private ltd. Company Registartion', link:'/private-limited-company-registration'},
                {name:'One Person Company Registration', link:'/one-person-company-registration'},
                {name:'LLP Registration', link:'/llp-registration'},
                {name:'Sole Proprietorship Registration', link:'/sole-proprietorship-registration'},
                {name:'Partnership Registration', link:'/partnership-registration'},
                {name:'ESI Registration', link:'/employee-state-insurance'},
                {name:'ISO Registration', link:'/iso-registration'},
                {name:'TAN Registration', link:'/tan-registration'},
                {name:'IEC Registration', link:'/iec-registration'},
                {name:'FSSAI Registration', link:'/fssai-registration'},
                {name:'TradeMark Registration', link:'/trademark-registration'},
            ]
        }
    ]},
    {name:'Filling Services',submenu:'true',sublinks:[
        {
            
            sublink:[
                {name:'Income Tax Return', link:'/incom-tax-return'},
                {name:'GST Filling', link:'/gst-filling'},
                {name:'Business Income Return', link:'/company-compliance'},
                {name:'Bulk Return Filling', link:'/bulk-return-filling'},
                {name:'TDS Return Filling', link:'/tds-return-filling'},
            ]
        }
    ]},
    
]